import { useProjectFetch } from '~/composables/use-api';

/**
 * API functions for managing role policy assignments.
 *
 * Uses dedicated endpoint for connecting policies:
 * - POST /{project}/roles/{role_id}/policies - connect a policy
 * - DELETE /{project}/roles/{role_id}/policies - disconnect a policy
 */

/**
 * Attach policies to a role.
 *
 * @param roleId - The role ID
 * @param policyIds - Array of policy IDs to attach
 */
export async function connectRolePolicies(roleId: string, policyIds: string[]): Promise<void> {
	if (policyIds.length === 0) return;

	const fetch = useProjectFetch();

	// Backend only supports connecting one policy at a time
	await Promise.all(
		policyIds.map((policyId) =>
			fetch(`roles/${roleId}/policies`, {
				method: 'POST',
				body: { policyId },
			}),
		),
	);
}

/**
 * Detach policies from a role.
 *
 * @param roleId - The role ID
 * @param policyIds - Array of policy IDs to detach
 */
export async function disconnectRolePolicies(roleId: string, policyIds: string[]): Promise<void> {
	if (policyIds.length === 0) return;

	const fetch = useProjectFetch();

	// Backend only supports disconnecting one policy at a time
	await Promise.all(
		policyIds.map((policyId) =>
			fetch(`roles/${roleId}/policies`, {
				method: 'DELETE',
				body: { policyId },
			}),
		),
	);
}
